import { useMemo } from "react";
import { useLocation } from "react-router-dom";
export default (function () {
    var search = useLocation().search;
    return useMemo(function () { return new URLSearchParams(search); }, [search]);
});
